import React from "react";
import classes from "./SmallDetail.module.scss";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

function SmallDetail(props: Props) {
  return <span className={classes.text}>{props.children}</span>;
}

export default SmallDetail;
